// extracted by mini-css-extract-plugin
export default {"container":"UploadsList__container___i3t5S"};